import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Omsetning from './Omsetning.jsx'
import MatrikkelenhetIcon from '../../../images/Matrikkelenhet.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class OmsetningList extends Component {
    state = {
        omsetninger: [],
        isLoading: false,
        isOmsetningerLoaded: false,
        isOpened: false,
        continuationToken: null        
    }

    getOmsetninger = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/omsetning`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                omsetninger: [...this.state.omsetninger, ...data.omsetninger].sort(this.omsetningComparer),
                isLoading: false,
                isOmsetningerLoaded: true,
                continuationToken: data.nextContinuationToken                
            })
        })
      }

      omsetningComparer = (a, b) => {
        if (a.registreringstidspunkt == null || b.registreringstidspunkt == null) return -1
        var firstDate = new Date(a.registreringstidspunkt)
        var secondDate = new Date(b.registreringstidspunkt)

        if (firstDate > secondDate) return -1
        if (firstDate < secondDate) return 1
        return 0
    }

      toggleOmsetninger = () => {
        if (!this.state.isOmsetningerLoaded) {
            this.getOmsetninger()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        //var antallKlager = this.state.continuationToken ? `${this.state.klager.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleOmsetninger}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={MatrikkelenhetIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('omsetninger')} {this.state.isOmsetningerLoaded && `(${this.state.omsetninger.length})`}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.omsetninger.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.omsetninger.map((o, index) => {return (<Omsetning key={o.registreringstidspunkt} omsetning={o} antall={this.state.omsetninger.length} isLast={index==this.state.omsetninger.length-1} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getOmsetninger}>
                                <span>{t('hent.omsetninger')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(OmsetningList)